import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class PodcastApiBaseUrlInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    handler: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return handler.handle(
      req.clone({
        url: `${environment.apiUrl}/wdv/${req.url}`,
      }),
    );
  }
}
